<template>
  <SlideSidebarContainer>
    <template v-slot:title>
      <div class="title" :style="{'--color': `#${category.color}`}">
        <div class="title__icon" v-html="category.svg"></div>
        {{ category.name }}
      </div>
    </template>

    <ul
      :style="{'--color': `#${category.color}`}"
    >
      <li
        v-for="subCategory in subCategories"
        :key="subCategory.id"
        class="nav__item"
      >
        <router-link
          class="nav__link"
          :to="subCategory.url"
        >
          {{ subCategory.name }}
        </router-link>
      </li>
    </ul>
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'

  export default {
    components: {
      SlideSidebarContainer,
    },

    props: {
      category: { type: Object, default: () => ({}) }
    },

    computed: {
      subCategories () {
        return [this.category].concat(this.category.categories)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .title {
    display: flex;
    color: $white300;

    &__icon {
      margin-right: 5px;
      width: 27px;
      height: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 25%;

      ::v-deep svg {
        width: 16px;
      }
    }
  }

  .nav {
    &__item {
      position: relative;
      transition: .5s all;
      padding: 16px 0 24px;

      &:hover {
        border-color: transparent;
      }
    }

    &__link {
      width: 100%;
      position: relative;
      display: inline-block;
      color: $white300;
      transition: .5s all;
    }
  }
</style>